import Axios from 'axios';

import { getAlert, randomDelay, getData, parseCurrency, getSpRunNumber } from './SamuiUtils';
import { formatDateTime, getCreateDateTime, formatThaiDateUiToDate } from './DateUtils';

export async function InvoiceHandleSubmit(
    dataType, // BI = ใบวางบิล, SO = ใบขาย
    arId,
    arCode,
    arName,
    arTaxNo,
    arAdd1,
    arAdd2,
    arAdd3,
    arProvince,
    arZipcode,
    arContact1,
    arContact2,
    arTel1,
    arTel2,
    docDate,
    docFor,
    refDocId,
    refDoc,
    refDocDate,
    docRemark1,
    isVatChecked
) {
    try {
        // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
        await randomDelay();

        let maxInv = "UNKNOWN";  // กำหนดค่าเริ่มต้น

        if (dataType === "SO") {
            const getSoById = await getData('SO_H', `Doc_Id = ${refDocId}`);
            if (getSoById && getSoById.length > 0) {
                const docStatusPaid = getSoById[0].Doc_Status_Paid ? parseCurrency(getSoById[0].Doc_Status_Paid) : null;
                const docStatusPaidType = getSoById[0].Doc_Status_Paid_Type ? parseCurrency(getSoById[0].Doc_Status_Paid_Type) : null;
                const isVat = getSoById[0].IsVat ? parseCurrency(getSoById[0].IsVat) : null;

                let prefix = "INV";
                if (docStatusPaid === 1) {
                    prefix = isVat === 2 ? "CS" : "INV";
                } else if (docStatusPaidType === 4) {
                    prefix = isVat === 2 ? "DSR" : "INV";
                } else {
                    prefix = isVat === 2 ? "CS" : "INV";
                }

                const runNumber = await getSpRunNumber(prefix);
                if (!runNumber) {
                    getAlert("FAILED", "ไม่สามารถสร้างเลขที่เอกสารได้");
                    return;
                }
                maxInv = runNumber;
            } else {
                getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบใบขาย");
                return;  // ออกจากฟังก์ชัน
            }
        } else if (dataType === "BI") {
            if (isVatChecked) {
                const runNumber = await getSpRunNumber("INV");
                if (!runNumber) {
                    getAlert("FAILED", "ไม่สามารถสร้างเลขที่เอกสารได้");
                    return;
                }
                maxInv = runNumber;
            } else {
                maxInv = refDoc;
            }
        } else {
            getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบประเภทเอกสาร");
            return;  // ออกจากฟังก์ชัน
        }

        if (!arId && !arCode) {
            getAlert("FAILED", "ไม่สามารถบันทึกได้เนื่องจากไม่พบผู้ขาย");
            return;
        }

        const formMasterData = {
            comp_id: window.localStorage.getItem('company'),
            doc_no: maxInv,
            doc_date: docDate,
            doc_status: parseCurrency("1"),
            doc_status_transport: parseCurrency("1"),
            doc_status_receive: parseCurrency("1"),
            doc_status_paid: parseCurrency("1"),
            doc_status_paid_type: parseCurrency("1"),
            doc_code: null,
            doc_type: null,
            doc_for: docFor,
            doc_is_picking_list: null,
            doc_is_inv: "Y",
            doc_inv_no: maxInv,
            doc_is_inv_from: dataType === 'SO' ? parseCurrency("1") : parseCurrency("2"),
            ref_doc_id: refDocId,
            ref_doc: refDoc,
            ref_doc_date: refDocDate,
            ref_project_id: null,
            ref_project_no: null,
            transport_type: null,
            doc_remark1: docRemark1,
            doc_remark2: null,
            ar_id: arId,
            ar_code: arCode,
            ar_name: arName,
            ar_tax_no: arTaxNo,
            doc_due_date: docDate,
            action_hold: null,
            discount_value: null,
            discount_value_type: null,
            discount_cash: null,
            discount_cash_type: null,
            discount_transport: null,
            discount_transport_type: null,
            is_vat: isVatChecked ? parseCurrency("1") : parseCurrency("2"),
            doc_seq: formatDateTime(new Date()),
            credit_term: null,
            credit_term1_day: null,
            credit_term1_remark: null,
            credit_term2_remark: null,
            acc_code: null,
            emp_name: null,
            created_date: formatThaiDateUiToDate(getCreateDateTime()),
            created_by_name: window.localStorage.getItem('name'),
            created_by_id: window.localStorage.getItem('emp_id'),
            update_date: null,
            update_by_name: null,
            update_by_id: null,
            approved_date: null,
            approved_by_name: null,
            approved_by_id: null,
            cancel_date: null,
            cancel_by_name: null,
            cancel_by_id: null,
            approved_memo: null,
            printed_status: null,
            printed_date: null,
            printed_by: null,
            ar_add1: arAdd1,
            ar_add2: arAdd2,
            ar_add3: arAdd3,
            ar_province: arProvince,
            ar_zipcode: arZipcode,
            ar_contact1: arContact1,
            ar_contact2: arContact2,
            ar_tel1: arTel1,
            ar_tel2: arTel2
        };

        const response = await Axios.post(`${process.env.REACT_APP_API_URL}/api/create-inv-h`, formMasterData, {
            headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' },
        });

        if (response.data.status === 'OK') {
            const tableMap = {
                SO: { table: 'SO_H', doc_is_inv: "Y", doc_is_inv_from: 1 },
                BI: { table: 'BL_H', doc_is_inv: parseCurrency("1"), doc_is_inv_from: 2 },
            };

            const { table, doc_is_inv, doc_is_inv_from } = tableMap[dataType] || {};

            const formUpdateData = {
                table,
                doc_is_inv,
                doc_inv_no: maxInv,
                doc_is_inv_from: parseCurrency(doc_is_inv_from),
                where: `WHERE Doc_Id = '${refDocId}'`,
            };

            await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-invoice`, formUpdateData, {
                headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' },
            });

            return response;
        }
    } catch (error) {
        getAlert("FAILED", error.response?.data?.message || error.message);
        return null;
    }
}

export async function InvoiceHandleUpdate(formMasterList) {
    try {
        if (!formMasterList.arID && !formMasterList.arCode) {
            getAlert("FAILED", "ไม่สามารถแก้ไขได้เนื่องจากไม่พบผู้ขาย");
            return;
        }

        const formMasterData = {
            comp_id: formMasterList.compId,
            doc_no: formMasterList.docNo,
            doc_date: formMasterList.docDate,
            doc_status: formMasterList.docStatus,
            doc_status_transport: formMasterList.docStatusTransport,
            doc_status_receive: formMasterList.docStatusReceive,
            doc_status_paid: formMasterList.docStatusPaid,
            doc_status_paid_type: formMasterList.docStatusPaidType,
            doc_code: formMasterList.docCode,
            doc_type: formMasterList.docType,
            doc_for: formMasterList.docFor,
            doc_is_picking_list: formMasterList.docIsPickingList,
            doc_is_inv: formMasterList.docIsInv,
            doc_inv_no: formMasterList.docInvNo,
            doc_is_inv_from: formMasterList.docIsInvFrom,
            ref_doc_id: formMasterList.refDocId,
            ref_doc: formMasterList.refDoc,
            ref_doc_date: formMasterList.refDocDate,
            ref_project_id: formMasterList.refProjectID,
            ref_project_no: formMasterList.refProjectNo,
            transport_type: formMasterList.transportType,
            doc_remark1: formMasterList.docRemark1,
            doc_remark2: formMasterList.docRemark2,
            ar_id: formMasterList.arID,
            ar_code: formMasterList.arCode,
            ar_name: formMasterList.arName,
            ar_tax_no: formMasterList.arTaxNo,
            doc_due_date: formMasterList.docDueDate,
            action_hold: formMasterList.actionHold,
            discount_value: formMasterList.discountValue,
            discount_value_type: formMasterList.discountValueType,
            discount_cash: formMasterList.discountCash,
            discount_cash_type: formMasterList.discountCashType,
            discount_transport: formMasterList.discountTransport,
            discount_transport_type: formMasterList.discountTransportType,
            is_vat: formMasterList.isVat,
            doc_seq: formMasterList.docSEQ,
            credit_term: formMasterList.creditTerm,
            credit_term1_day: formMasterList.creditTerm1Day,
            credit_term1_remark: formMasterList.creditTerm1Remark,
            credit_term2_remark: formMasterList.creditTerm2Remark,
            acc_code: formMasterList.accCode,
            emp_name: formMasterList.empName,
            created_date: formatThaiDateUiToDate(formMasterList.createdDate),
            created_by_name: formMasterList.createdByName,
            created_by_id: formMasterList.createdById,
            update_date: getCreateDateTime(),
            update_by_name: window.localStorage.getItem('name'),
            update_by_id: window.localStorage.getItem('emp_id'),
            approved_date: formMasterList.approvedDate,
            approved_by_name: formMasterList.approvedByName,
            approved_by_id: formMasterList.approvedById,
            cancel_date: formMasterList.cancelDate,
            cancel_by_name: formMasterList.cancelByName,
            cancel_by_id: formMasterList.cancelById,
            approved_memo: formMasterList.approvedMemo,
            printed_status: formMasterList.printedStatus,
            printed_date: formMasterList.printedDate,
            printed_by: formMasterList.printedBy,
            ar_add1: formMasterList.arAdd1,
            ar_add2: formMasterList.arAdd2,
            ar_add3: formMasterList.arAdd3,
            ar_province: formMasterList.arProvince,
            ar_zipcode: formMasterList.arZipcode,
            ar_contact1: null,
            ar_contact2: null,
            ar_tel1: null,
            ar_tel2: null
        };

        const response = await Axios.post(`${process.env.REACT_APP_API_URL}/api/update-inv-h`, formMasterData, {
            headers: { key: 'SAMUI1WoV5UbrGPq5iOXS2SS4ODR9999' },
        });

        if (response.data.status === 'OK') {
            return response;
        }
    } catch (error) {
        getAlert("FAILED", error.response?.data?.message || error.message);
        return null;
    }
}
